import * as z from "zod";

import { fastumTicketSchema } from "./fastum-ticket";

export const issueFastumTicketSchema = fastumTicketSchema.pick({
  id: true,
  externalId: true,
  title: true,
  status: true,
  link: true,
});

export type IssueFastumTicket = z.infer<typeof issueFastumTicketSchema>;
